import { render, staticRenderFns } from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=template&id=7db534ca&scoped=true&"
import script from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=script&lang=js&"
export * from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db534ca",
  null
  
)

export default component.exports